import { AuxiliumComponent } from "../auxilium-component";

export class FrameSidebar extends AuxiliumComponent {
	static observedAttributes = ["padding", "collapsed"];

	constructor() {
		super();

		const preloadCollapse = window.localStorage.getItem("collapseSidebar");

		this.side = this.getAttribute("side") ?? "left";
		this.heading = this.getAttribute("heading");
		this.headingSize = this.getAttribute("heading-size") ?? "4";
		this.description = this.getAttribute("description") ?? this.heading ?? "Application sidebar";
		this.padding = this.getAttribute("padding") ?? (this.closest("chip-frame").layout !== "container" ? "xl" : "0");
		this.collapsible = this.hasAttribute("collapsible");
		this.collapsed = preloadCollapse != null && this.collapsible ? preloadCollapse === "true" : this.hasAttribute("collapse");
		this.brand = this.getAttribute("brand") ?? "";
	}

	parsedCallback() {
		const nav = document.createElementWithContents("nav", this.querySelector(":scope>ul") ?? this.appendChild(document.createElementWithContents("ul", null, { className: "sidebar__list" })), { ariaLabel: this.description });

		if (this.heading) {
			nav.prepend(document.createElementWithContents("chip-header", this.heading, {
				size: this.headingSize,
				element: "h2"
			}));
		}

		if (this.brand || this.collapsible) {
			const topbar = document.createElementWithContents("div", null, { className: "sidebar__top" });

			if (this.brand) {
				topbar.appendChild(document.createElementWithContents("chip-header", this.brand, {
					size: "3",
					link: "~/"
				}));
			}

			if (this.collapsible) {
				topbar.appendChild(document.createElementWithContents("chip-button", null, {
					variation: "body",
					buttonStyle: "icon",
					size: "lg",
					icon: "fas fa-bars",
					onclick: () => this.collapsed = !this.collapsed
				}));
			}

			nav.prepend(topbar);
		}

		nav.append(...[...this.childNodes].filter(x => !x.matches?.("chip-sidebaritem, chip-sidebarheader")));
		this.appendChild(nav);

		this.querySelectorAll(":scope > chip-sidebaritem, :scope > chip-sidebarheader").forEach(x => this.AddItem(x));
		this.#RefreshTooltips();
	}

	AddItem(item) {
		this.querySelector(":scope>ul, :scope>nav>ul").appendChild(document.createElementWithContents("li", item, { className: item.nodeName === "CHIP-SIDEBARITEM" ? "sidebar-list-item" : "sidebar-list__section-title" }))
	}

	ClearItems() {
		this.querySelector(":scope>ul, :scope>nav>ul").innerHTML = "";
	}

	attributeChanged(name, _, newValue) {
		if (name === "collapsed") {
			window.localStorage.setItem("collapseSidebar", this.IsAttributeValueTrue(newValue));
		}

		this.#RefreshTooltips();
	}

	#RefreshTooltips() {
		this.querySelectorAll("chip-button[variation='sidebar']").forEach(button => {
			button.setAttribute("tooltip-placement", "right");
			button.setAttribute("tooltip", this.collapsed ? button.textContent.trim() : "");
		});
	}
}